export type DepositUnit = 'fixed' | 'percent';

export interface DepositLike {
  cost?: number | string;
  type?: DepositUnit;
}

/** Risolve l'acconto (fisso in € o percentuale sul totale) nel suo controvalore in euro. */
export function resolveDepositEuro(deposit: DepositLike | undefined, total: number): number {
  const raw = +(deposit?.cost ?? 0) || 0;
  return deposit?.type === 'percent' ? total * (raw / 100) : raw;
}
